import React, { useEffect, useRef, useState } from "react";
import { Checkbox, Form, Input, InputNumber, Modal, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import {
  fetchGlAccount,
  fetchPrItp,
  fetchSlipHeader,
} from "../../../../features/dropdown/dropdownSlice";

const { TextArea } = Input;

const AddPayrollModal = ({ open, handleCancel, handleFetchData, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { slipHeader, loading, prItp,glAccount } = useSelector((state) => state.dropdown);
  const { saving } = useSelector((state) => state.save);

  const [formData, setFormData] = useState(prodd);

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };


  const onChangeOther = (value, fieldName) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  async function handleSelectChange(value, formName) {
    await setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const [value, setValue] = useState(prodd?.piRecur === 1 ? true : false);

  const onChangeCheck = (e) => {
    setValue(e.target.checked);
  };

  const onFinish = async (data) => {
    if (!formData?.shId) {
      toast.error("Please select header");
      return;
    }
    if (!formData?.itId) {
      toast.error("Please select item type");
      return;
    }
    const res = await dispatch(
      save({
        piId: prodd?.piId ? prodd?.piId : null,
        piItemcode: formData?.piItemcode,
        piItemname: formData?.piItemname,
        shId: formData?.shId,
        itId: formData?.itId, 
        piItempos: formData?.piItempos, 
        piRecur:value ? 1 : 0,
        acDesc:formData?.acDesc,
        url: "hr/savePrItem.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await setFormData({});
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  async function fetchSlipHeaderData(page, size) {
    dispatch(fetchSlipHeader());
  }

  async function fetchPrItpData(page, size) {
    dispatch(fetchPrItp());
  }

  async function fetchGlAccountData(page, size) {
    dispatch(fetchGlAccount());
  }


  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);

  useEffect(() => {
    setValue(prodd?.piRecur === 1 ? true : false);
  }, [prodd]);

 
  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={
          prodd
            ? `Edit payroll item ${prodd?.piItemname}`
            : "Add payroll item details"
        }
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <div className="grid grid-cols-2 gap-x-5">
            <Form.Item
              label="Item Code"
              rules={[
                {
                  required: true,
                  message: "Enter iIem Code",
                },
              ]}
            >
              <Input
                required
                name="piItemcode"
                onChange={onChange}
                value={formData?.piItemcode}
                className="input"
              />
            </Form.Item>

            <Form.Item
              label="Item Name"
              rules={[
                {
                  required: true,
                  message: "Enter iIem Name",
                },
              ]}
            >
              <Input
                required
                name="piItemname"
                onChange={onChange}
                value={formData?.piItemname}
                className="input"
              />
            </Form.Item>

            <Form.Item
              className=""
              label={<span>Header</span>}
              rules={[
                {
                  required: true,
                  message: "Please select header",
                },
              ]}
            >
              <Select
                name="shId"
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  slipHeader?.length > 0 &&
                  slipHeader?.map((item) => ({
                    value: item?.shId,
                    label: item?.shHdrname,
                  }))
                }
                onChange={(value) => {
                  handleSelectChange(value, "shId");
                }}
                value={formData?.shId}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                onDropdownVisibleChange={() => {
                  fetchSlipHeaderData();
                }}
                dropdownRender={(menu) => (
                  <>
                    {loading && (
                      <div
                        style={{
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        <Spin className="sms-spin" />
                      </div>
                    )}
                    {menu}
                  </>
                )}
              />
            </Form.Item>

            <Form.Item
              className=""
              label={<span>Item Type</span>}
              rules={[
                {
                  required: true,
                  message: "Please select item type",
                },
              ]}
            >
              <Select
                name="itId"
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  prItp?.length > 0 &&
                  prItp?.map((item) => ({
                    value: item?.itId,
                    label: item?.itItypename,
                  }))
                }
                onChange={(value) => {
                  handleSelectChange(value, "itId");
                }}
                value={formData?.itId}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                onDropdownVisibleChange={() => {
                  fetchPrItpData();
                }}
                dropdownRender={(menu) => (
                  <>
                    {loading && (
                      <div
                        style={{
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        <Spin className="sms-spin" />
                      </div>
                    )}
                    {menu}
                  </>
                )}
              />
            </Form.Item>

            <Form.Item
            label="Item Position"
            rules={[
              {
                required: true,
                message: "Enter item Position",
              },
            ]}
          >
            <InputNumber
              name="piItempos"
              value={formData?.piItempos}
              min={0}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              onChange={(value) => onChangeOther(value, "piItempos")} 
              className="input flex"
            />
          </Form.Item>


            

            <Form.Item
             label="Recurrs"
             rules={[
               {
                 required: false,
                 message: "check recurrs",
               },
             ]}>
            <Checkbox checked={value} value={value} onChange={onChangeCheck}>
            </Checkbox>
          </Form.Item>

          <Form.Item
              className=""
              label={<span>Gl Account</span>}
              rules={[
                {
                  required: true,
                  message: "Please select Gl Account",
                },
              ]}
            >
              <Select
                name="acDesc"
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  glAccount?.length > 0 &&
                  glAccount?.map((item) => ({
                    value: item?.acId,
                    label: item?.acNo + ' - ' + item?.acDesc,
                  }))
                }
                onChange={(value) => {
                  handleSelectChange(value, "acDesc");
                }}
                value={formData?.acDesc}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                onDropdownVisibleChange={() => {
                  fetchGlAccountData();
                }}
                dropdownRender={(menu) => (
                  <>
                    {loading && (
                      <div
                        style={{
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        <Spin className="sms-spin" />
                      </div>
                    )}
                    {menu}
                  </>
                )}
              />
            </Form.Item>
          </div>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddPayrollModal;
